'use client';

export const LineupViewSkeleton = () => {
	return (
		<div className="flex w-full flex-col">
			{/* ScoreCardsLayout structure */}
			<div className="py-9">
				{/* Title header */}
				<div className="w-full flex justify-between items-center">
					<div className="h-6 w-40 animate-pulse rounded bg-gray-200 md:h-8 md:w-48" />
				</div>

				{/* LineupCard Grid */}
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-6 pt-6">
					{[...Array(4)].map((_, index) => (
						<div key={index} className="bg-white border border-[#EF6820] rounded-lg p-4 w-full lg:max-w-[600px]">
							{/* LineupCard Header */}
							<div className="flex justify-between mb-3">
								<div className="h-5 w-32 animate-pulse rounded bg-gray-200 mb-2 sm:mb-0" />
								<div className="h-8 w-20 animate-pulse rounded border bg-gray-200" />
							</div>

							{/* Date/Time/Court Info */}
							<div className="text-sm mb-4 space-y-1">
								<div className="h-4 w-40 animate-pulse rounded bg-gray-200" />
								<div className="h-4 w-32 animate-pulse rounded bg-gray-200" />
							</div>

							{/* Away Team Section */}
							<div className="mb-6">
								<div className="h-5 w-36 animate-pulse rounded bg-gray-200 text-center mb-4 mx-auto" />
								<div className="flex flex-col gap-4 sm:flex-row sm:gap-8">
									{/* Player 1 Select */}
									<div className="flex-1">
										<div className="h-10 w-full animate-pulse rounded border bg-gray-200" />
									</div>
								</div>
							</div>

							{/* VS Separator */}
							<div className="flex items-center justify-center mb-6">
								<div className="flex-1 h-px bg-gray-300" />
								<span className="px-4 text-gray-500 font-medium">vs</span>
								<div className="flex-1 h-px bg-gray-300" />
							</div>

							{/* Home Team Section */}
							<div>
								<div className="h-5 w-36 animate-pulse rounded bg-gray-200 text-center mb-4 mx-auto" />
								<div className="flex flex-col gap-4 sm:flex-row sm:gap-8">
									{/* Player 1 Select */}
									<div className="flex-1">
										<div className="h-10 w-full animate-pulse rounded border bg-gray-200" />
									</div>
								</div>
							</div>
						</div>
					))}
				</div>

				{/* TieBreakerFormatTitle skeleton */}
				<div className="py-10">
					<div className="text-center space-y-4">
						<div className="h-6 w-48 animate-pulse rounded bg-gray-200 mx-auto" />
						<div className="h-4 w-64 animate-pulse rounded bg-gray-200 mx-auto" />
						<div className="h-10 w-32 animate-pulse rounded-md bg-gray-200 mx-auto" />
					</div>
				</div>
			</div>
		</div>
	);
};
